/* =======================================================================
   zeitreise-configurator.js — Bedienung des Konfigurators
   Gezeichnet wird ausschliesslich über lapse-render.js (window.LapseRender),
   denselben Code, den das Druck-Tool verwendet.
   ===================================================================== */
(function(){
const R = window.LapseRender;

/* Shop-Daten (nur hier, nicht im Zeichen-Code).
   Die Preise werden beim Laden aus Shopify gelesen (loadPrices); die Werte
   hier dienen nur als Rückfall, falls die Abfrage scheitert. */
const PRODUCT_HANDLE = 'lapse-poster-dein-ort-im-wandel-der-zeit';
const SHOP = {
  '50x70-quer': {preis:59.90, variantId:58026168222078},
  '50x70-hoch': {preis:59.90, variantId:58026168254846},
  '30x40-quer': {preis:49.90, variantId:58026168287614},
  '30x40-hoch': {preis:49.90, variantId:58026168320382},
};
async function loadPrices(){
  try {
    const res = await fetch(`/products/${PRODUCT_HANDLE}.js`, {headers:{'Accept':'application/json'}});
    if (!res.ok) return;
    const p = await res.json();
    for (const v of (p.variants || [])){
      const fmt = Object.keys(SHOP).find(k => SHOP[k].variantId === v.id);
      if (fmt && typeof v.price === 'number') SHOP[fmt].preis = v.price / 100;   // Shopify liefert Rappen
    }
    price();
  } catch(e) { /* Rückfallwerte bleiben */ }
}

// Standard-Ausschnitt: "Mittel"
const ZOOM_START = R.ZOOM.mittel ? 'mittel' : Object.keys(R.ZOOM)[0];
const state = {
  addr:null, fmt:'50x70-quer', design:'chronik', zoom:ZOOM_START,
  colour:'sand', pin:false, pinKind:'tropfen', pinColour:'#C8412A',
};
let maps = null, mapKey = '';

function spec(){
  const a = state.addr || {};
  return { E:a.E, N:a.N, titel:a.titel, ort:a.ort, label:a.label,
           fmt:state.fmt, design:state.design, zoom:state.zoom, colour:state.colour,
           pin:state.pin, pinKind:state.pinKind, pinColour:state.pinColour };
}

/* ---------- Bedienelemente ---------- */
function buttons(host, entries, key, onPick){
  host.innerHTML = '';
  for (const [id, cfg] of entries){
    const b = document.createElement('button');
    b.className = 'opt'; b.type = 'button';
    b.setAttribute('aria-pressed', state[key] === id);
    b.innerHTML = cfg.sub ? `${cfg.label}<small>${cfg.sub}</small>` : cfg.label;
    b.onclick = () => { state[key] = id; buttons(host, entries, key, onPick); onPick && onPick(); };
    host.appendChild(b);
  }
}
buttons(document.getElementById('fmt'),
        Object.entries(R.FORMATS).map(([k,v]) => [k,{label:v.label + ' cm', sub:v.sub}]), 'fmt', reload);
buttons(document.getElementById('design'),
        Object.entries(R.DESIGNS).map(([k,v]) => [k,{label:v.label}]), 'design', reload);
buttons(document.getElementById('zoom'),
        Object.entries(R.ZOOM).map(([k,v]) => [k,{label:v.label}]), 'zoom', reload);
buttons(document.getElementById('pin'),
        Object.entries(R.PINS).map(([k,v]) => [k,{label:v}]), 'pinKind', redraw);

function swatches(host, entries, key, style){
  host.innerHTML = '';
  for (const [id, label, bg] of entries){
    const b = document.createElement('button');
    b.className = 'sw' + (style ? ' ' + style : ''); b.type = 'button'; b.title = label;
    b.style.background = bg;
    if (bg.toLowerCase() === '#ffffff') b.style.boxShadow = 'inset 0 0 0 1px var(--lc-line)';
    b.setAttribute('aria-label', label);
    b.setAttribute('aria-pressed', String(state[key]).toLowerCase() === id.toLowerCase());
    b.onclick = () => { state[key] = id; swatches(host, entries, key, style); redraw(); };
    host.appendChild(b);
  }
}
swatches(document.getElementById('colour'),
         Object.entries(R.COLOURS).map(([k,c]) => [k, c.label, c.bg]), 'colour');
const pinColourHost = document.getElementById('pinColour');
if (pinColourHost) swatches(pinColourHost,
         Object.entries(R.PIN_COLOURS).map(([hex,l]) => [hex, l, hex]), 'pinColour', 'sw-klein');

const pinOnHost = document.getElementById('pinOn'), pinHost = document.getElementById('pin');
function pinToggle(){
  pinOnHost.innerHTML = '';
  for (const [val,label] of [[true,'Ja'],[false,'Nein']]){
    const b = document.createElement('button');
    b.className = 'opt'; b.type = 'button'; b.textContent = label;
    b.setAttribute('aria-pressed', state.pin === val);
    b.onclick = () => { state.pin = val; pinToggle(); redraw(); };
    pinOnHost.appendChild(b);
  }
  pinHost.hidden = !state.pin;
  const pcw = document.getElementById('pinColourWrap');
  if (pcw) pcw.hidden = !state.pin;
}
pinToggle();

/* ---------- Adresssuche ---------- */
const addrIn = document.getElementById('addr'), sugg = document.getElementById('suggest');
let sugTimer;
addrIn.oninput = () => {
  clearTimeout(sugTimer);
  const q = addrIn.value.trim();
  if (q.length < 3){ sugg.innerHTML = ''; return; }
  sugTimer = setTimeout(async () => {
    try{
      const u = 'https://api3.geo.admin.ch/rest/services/api/SearchServer?type=locations'
              + '&origins=address&sr=2056&limit=6&searchText=' + encodeURIComponent(q);
      const j = await (await fetch(u)).json();
      sugg.innerHTML = '';
      const seen = new Set();
      (j.results || []).forEach(hit => {
        const a = hit.attrs, text = a.label.replace(/<[^>]+>/g,'');
        const key = text.replace(/(\d+[a-zA-Z]?)\.\d+(?=\s)/, '$1');
        if (seen.has(key)) return; seen.add(key);
        const li = document.createElement('li');
        li.textContent = key;
        li.onclick = () => choose(text, a.y, a.x);
        sugg.appendChild(li);
      });
    }catch(e){ sugg.innerHTML = '<li>Suche nicht erreichbar</li>'; }
  }, 220);
};
function choose(label, E, N){
  // Eingangszusatz des Gebäuderegisters entfernen ("1a.1" → "1a")
  label = label.replace(/(\d+[a-zA-Z]?)\.\d+(?=\s)/, '$1');
  const m = label.match(/^(.*?)\s+(\d{4})\s+(.*)$/);
  state.addr = { label, E, N,
                 titel: (m ? m[1] : label).replace(/\s*#\s*$/,'').replace(/,$/,'').trim(),
                 ort:   m ? `${m[2]} ${m[3]}` : '' };
  addrIn.value = label; sugg.innerHTML = '';
  reload();
}

/* ---------- Karten + Zeichnen ---------- */
async function reload(){
  if (!state.addr){ redraw(); return; }
  const s = spec(), {hw, hh} = R.extent(s);
  const key = [s.E, s.N, hw.toFixed(1), hh.toFixed(1)].join('|');
  if (key === mapKey){ redraw(); return; }
  mapKey = key; maps = null;
  const frame = document.getElementById('frame');
  frame.classList.add('loading'); redraw();
  try {
    const m = await R.loadMaps(s, 'preview');
    if (key !== mapKey) return;
    maps = m;
  } catch(e) { /* leere Felder bleiben sichtbar */ }
  frame.classList.remove('loading');
  redraw();
}

const cv = document.getElementById('cv'), ctx = cv.getContext('2d');
cv.addEventListener('contextmenu', e => e.preventDefault());

let cssPxPerMmNow = 1;
function redraw(){
  const s = spec(), F = R.FORMATS[s.fmt];
  const stage = document.querySelector('.stage-inner');
  const maxW = Math.max(240, stage.clientWidth - 24);
  const maxH = Math.max(240, Math.min(window.innerHeight - 210, 620));
  const cssPxPerMm = Math.min(maxW / F.w, maxH / F.h);
  const dpr = window.devicePixelRatio || 1;
  cv.width  = Math.round(F.w*cssPxPerMm*dpr);
  cv.height = Math.round(F.h*cssPxPerMm*dpr);
  cv.style.width  = (F.w*cssPxPerMm) + 'px';
  cv.style.height = (F.h*cssPxPerMm) + 'px';
  document.getElementById('frame').dataset.frame = 'keiner';
  R.draw(ctx, s, maps, { pxPerMm: cssPxPerMm*dpr, bleed: 0, watermark: true });
  cssPxPerMmNow = cssPxPerMm; hiDirty = true;
  if (lupeAktiv) zeichneLupe();
  price();
}

/* ---------- Lupe ----------
   Zeichnet das Poster in höherer Auflösung (mit Wasserzeichen) und zeigt den
   Ausschnitt unter dem Zeiger. Desktop: Maus über die Vorschau.
   Touch: kurz gedrückt halten, dann ziehen. */
const LUPE = { groesse: 200, zoom: 2.6, maxPixel: 16e6 };
const hi = document.createElement('canvas'), hiCtx = hi.getContext('2d');
let hiDirty = true, lupeAktiv = false, lupeX = 0, lupeY = 0, lupeTouch = false;
const lupe = document.createElement('div');
lupe.className = 'lupe'; lupe.setAttribute('aria-hidden', 'true');
const lupeCv = document.createElement('canvas'); lupe.appendChild(lupeCv);
document.body.appendChild(lupe);

function baueHi(){
  if (!hiDirty) return;
  const s = spec(), F = R.FORMATS[s.fmt], dpr = window.devicePixelRatio || 1;
  let pxPerMm = cssPxPerMmNow * dpr * LUPE.zoom;
  const flaeche = F.w * F.h * pxPerMm * pxPerMm;
  if (flaeche > LUPE.maxPixel) pxPerMm *= Math.sqrt(LUPE.maxPixel / flaeche);
  hi.width = Math.round(F.w * pxPerMm); hi.height = Math.round(F.h * pxPerMm);
  R.draw(hiCtx, s, maps, { pxPerMm, bleed: 0, watermark: true });
  hiDirty = false;
}
function zeichneLupe(){
  if (!state.addr) { versteckeLupe(); return; }
  baueHi();
  const rect = cv.getBoundingClientRect(), dpr = window.devicePixelRatio || 1, G = LUPE.groesse;
  const rx = Math.min(Math.max(lupeX - rect.left, 0), rect.width);
  const ry = Math.min(Math.max(lupeY - rect.top, 0), rect.height);
  lupeCv.width = G * dpr; lupeCv.height = G * dpr;
  const lx = lupeCv.getContext('2d');
  const skala = hi.width / rect.width;              // Hi-Pixel pro CSS-Pixel
  const quelle = G * dpr * (skala / (dpr * LUPE.zoom)) ;  // Quellbreite in Hi-Pixeln
  lx.fillStyle = R.COLOURS[state.colour].bg; lx.fillRect(0, 0, lupeCv.width, lupeCv.height);
  lx.imageSmoothingQuality = 'high';
  lx.drawImage(hi, rx*skala - quelle/2, ry*skala - quelle/2, quelle, quelle, 0, 0, lupeCv.width, lupeCv.height);
  const versatz = lupeTouch ? G * 0.75 : 0;          // bei Touch über dem Finger
  lupe.style.left = (lupeX - G/2) + 'px';
  lupe.style.top  = (lupeY - G/2 - versatz) + 'px';
  lupe.classList.add('an');
}
function versteckeLupe(){ lupeAktiv = false; lupe.classList.remove('an'); }

cv.addEventListener('mousemove', e => {
  if (!state.addr) return;
  lupeTouch = false; lupeAktiv = true; lupeX = e.clientX; lupeY = e.clientY;
  requestAnimationFrame(zeichneLupe);
});
cv.addEventListener('mouseleave', versteckeLupe);

let halteTimer = null, startX = 0, startY = 0;
cv.addEventListener('touchstart', e => {
  if (!state.addr || e.touches.length !== 1) return;
  const t = e.touches[0]; startX = t.clientX; startY = t.clientY;
  clearTimeout(halteTimer);
  halteTimer = setTimeout(() => {
    lupeTouch = true; lupeAktiv = true; lupeX = startX; lupeY = startY; zeichneLupe();
  }, 220);
}, { passive: true });
cv.addEventListener('touchmove', e => {
  const t = e.touches[0];
  if (!lupeAktiv){
    if (Math.hypot(t.clientX - startX, t.clientY - startY) > 8) clearTimeout(halteTimer);  // normales Scrollen
    return;
  }
  e.preventDefault();
  lupeX = t.clientX; lupeY = t.clientY;
  requestAnimationFrame(zeichneLupe);
}, { passive: false });
['touchend', 'touchcancel'].forEach(ev => cv.addEventListener(ev, () => { clearTimeout(halteTimer); versteckeLupe(); }));
window.addEventListener('scroll', () => { if (!lupeTouch) versteckeLupe(); }, { passive: true });

function price(){
  const p = SHOP[state.fmt].preis;
  document.getElementById('price').textContent = state.addr ? `CHF ${p.toFixed(2)}` : '–';
  document.getElementById('priceNote').textContent = state.addr
      ? `${R.FORMATS[state.fmt].label} cm · gratis Versand` : 'Adresse eingeben';
  document.getElementById('cta').disabled = !state.addr;
}

/* ---------- Warenkorb ---------- */
/* Kleines Vorschaubild für den Warenkorb im Browser speichern
   (sections/lapse-cart-vorschau.liquid zeigt es dort an) */
function speichereVorschau(key, s){
  if (!key) return;
  const F = R.FORMATS[s.fmt], seite = 360, k = seite / Math.max(F.w, F.h);
  const c = document.createElement('canvas');
  c.width = Math.round(F.w * k); c.height = Math.round(F.h * k);
  R.draw(c.getContext('2d'), s, maps, { pxPerMm: k, bleed: 0, watermark: false });
  const SPEICHER = 'lapse-vorschau';
  let alle = {};
  try { alle = JSON.parse(localStorage.getItem(SPEICHER) || '{}'); } catch(_){}
  alle[key] = { src: c.toDataURL('image/jpeg', 0.82), t: Date.now() };
  const sortiert = Object.entries(alle).sort((a, b) => b[1].t - a[1].t).slice(0, 12);   // nur die neusten behalten
  try { localStorage.setItem(SPEICHER, JSON.stringify(Object.fromEntries(sortiert))); } catch(_){}
}

document.getElementById('cta').onclick = async () => {
  if (!state.addr) return;
  const btn = document.getElementById('cta'), label = btn.textContent;
  btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
  const s = spec();
  const props = {
    'Adresse': s.label,
    'Gestaltung': R.DESIGNS[s.design].label,
    'Ausschnitt': R.ZOOM[s.zoom].label,
    'Farbe': R.COLOURS[s.colour].label,
    'Standortmarkierung': s.pin ? R.PINS[s.pinKind] : 'ohne',
  };
  if (s.pin) props['Farbe Markierung'] = R.PIN_COLOURS[Object.keys(R.PIN_COLOURS)
      .find(h => h.toLowerCase() === s.pinColour.toLowerCase())];
  // Versteckt für Kundschaft (Unterstrich), sichtbar in der Bestellung im Admin
  props['_Druckcode'] = R.encode(s);
  try {
    const res = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: SHOP[s.fmt].variantId, quantity:1, properties: props }] })
    });
    if (!res.ok){
      let msg = ''; try { const j = await res.json(); msg = j.description || j.message || ''; } catch(_){}
      throw new Error(msg || ('HTTP ' + res.status));
    }
    try { const j = await res.json(); speichereVorschau(j.items && j.items[0] && j.items[0].key, s); } catch(_){}
    window.location.href = '/cart';
  } catch (e) {
    btn.disabled = false; btn.textContent = label;
    alert('Der Artikel konnte nicht zum Warenkorb hinzugefügt werden.' + (e.message ? '\n(' + e.message + ')' : ''));
  }
};

let rzT; window.addEventListener('resize', () => { clearTimeout(rzT); rzT = setTimeout(redraw, 120); });
window.__lapseState = state;          // für Tests
window.__lapseChoose = choose;
redraw();
R.loadFonts().then(redraw);
loadPrices();
})();
